export enum SettingsTab {
  LAYOUT = 'layout',
  SENTIMENT = 'sentiment',
  LANGUAGE_TIME = 'language_time',
  TRANSLATIONS = 'translations',
  HIGHLIGHTS = 'highlights',
  FILTERS = 'filters',
  ARTICLES = 'articles',
  METRICS = 'metrics',
  TAGS = 'tags',
}

export enum PreviewModeKey {
  INFINITE = 1,
  ARCHIVE = 0,
}
